/**
 * Generated by orval v8.9.1 🍺
 * Do not edit manually.
 * SVM API
 * SVM API documentation
 * OpenAPI spec version: 1.0
 */

export type DroneResponseStatus = (typeof DroneResponseStatus)[keyof typeof DroneResponseStatus];

export const DroneResponseStatus = {
    CLAIMED: 'CLAIMED',
    DISABLED: 'DISABLED',
    ENABLED: 'ENABLED',
    RELEASED: 'RELEASED'
} as const;
